/**
 * @component SVCSPD001_10TB
 * @title 계좌 > 스피드조회 등록 > 계좌조회
 * @description 계좌 > 스피드조회 등록 > 계좌조회
 * @asis H95101A
 * @properties
 * @linked-menu
 * @author 곽동현
 * @history
 *   [2026-04-21][곽동현] 초기 작성
 */
import { useTranslation } from 'react-i18next';
import { PageType, PropsWithPopup } from 'scbk-services';
import { withPageComponent } from 'scbk-shared-module';
import { DialogWrapper, Tabs, TabsContent, TabsList, TabsTrigger } from 'scbk-ui-web';
import SVCSPD001_11TB from './SVCSPD001_11TB';
import SVCSPD001_21TB from './SVCSPD001_21TB';

export default withPageComponent<PropsWithPopup>(
    'SVCSPD001_10TB',
    {
        type: PageType.FULL_POPUP,
        layoutOptions: {
            description: '계좌 > 스피드조회 등록 > 계좌조회',
        },
    },
    function ({ isOpen, setOpen }) {
        const { t } = useTranslation();

        return (
            <DialogWrapper
                title={t('SVCSPD001_10TB.001', '스피드조회')}
                isFull={true}
                open={isOpen}
                setOpen={setOpen}
                onClose={close}
            >
                <Tabs defaultValue="segment1">
                    <TabsList variant="segment">
                        <TabsTrigger value="segment1" variant="segment">
                            {t('SVCSPD001_10TB.002', '계좌조회')}
                        </TabsTrigger>
                        <TabsTrigger value="segment2" variant="segment">
                            {t('SVCSPD001_10TB.003', '증명서 발급확인')}
                        </TabsTrigger>
                    </TabsList>
                    <TabsContent value="segment1">
                        <SVCSPD001_11TB />
                    </TabsContent>
                    <TabsContent value="segment2">
                        <SVCSPD001_21TB />
                    </TabsContent>
                </Tabs>
            </DialogWrapper>
        );
    },
);
